import { ReactNode } from 'react';

export type ShowProps = {
  condition?: boolean;
  children: ReactNode;
};

export function Show({ children, condition }: ShowProps) {
  if (!condition) {
    return null;
  }
  return <>{children}</>;
}
